import styled from '@emotion/styled'
import { Radio } from 'antd'
import { StyledRadioGroup } from './CustomRadioGroup'

export const StyledUseBalance = styled.section`
  display: flex;
  margin-left: 80px;
  margin-bottom: 30px;
  flex-direction: column;
  .ant-checkbox-wrapper {
    margin-bottom: 10px;
  }

  .ant-checkbox-inner {
    border-color: #A1A1A1 !important;

    &:after {
      border-color: #A1A1A1 !important;
    }
  }

  .ant-checkbox + span {
    font-size: 14px;
    color: #A1A1A1;
    span {
      font-size: 12px;
      color: #9c9c9c;
    }
  }
`
export const StyledBalanceRadioGroup = styled(StyledRadioGroup)`
  /* background-color: #0e0e0e; */
  padding: 0 24px;
`

export const StyledUseBalanceRadio = styled(Radio)`
  display: flex;
  line-height: 30px;
  align-items: center;
  .ant-radio + span {
    flex: 1;
    display: inline-flex;
    color: #A1A1A1;
  }
  .balance {
    font-size: 14px;
    color: #ffc400;
  }
  .tips {
    font-size: 12px;
    color: #9c9c9c;
  }
`
